<template>
    <section class="font-poppins">
       <div class=" border ml-6 p-6 md:ml-0 md:p-2 md:text-sm md:border-0">
           <p class="text-blue-600">Password Settings</p>
           <p>Change or reset your account password</p>
           
           <div v-if="isPasswordChanged" class="border border-green-500 text-green-400 bg-green-100 p-2 mt-4">
               <p>Password successfully Changed</p>
           </div>

           <div class="mt-10">
               <form @submit.prevent="changePassword">
                   <div>
                       <label class="text-blue-600" for="oldPassword">Old Password</label> <br>
                       <input class="border w-full text-gray-400 p-2 mt-2 rounded-xl" :type="[showPassword ? 'text' : 'password']" name="oldPassword" id="oldPassword" v-model="oldPassword">
                       <span @click="showPassword = !showPassword">
                            <i class="fa  -ml-8 mt-4" :class="[showPassword ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                        </span>
                       <p v-if="oldPasswordValidity === 'invalid' " class="text-xs text-red-500">  Please enter your old password</p>
                   </div>

                   <div class="mt-4">
                       <label class="text-blue-600" for="newPassword">New Password</label> <br>
                       <input class="border w-full text-gray-400 p-2 mt-2 rounded-xl" :type="[showPassword2 ? 'text' : 'password']" name="newPassword" id="newPassword" v-model="newPassword">
                       <span @click="showPassword2 = !showPassword2">
                            <i class="fa  -ml-8 mt-4" :class="[showPassword2 ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                        </span>
                       <p v-if="newPasswordValidity === 'invalid' " class="text-xs text-red-500">Password must be greater than 8</p>
                   </div>

                   <div class="mt-4">
                       <label class="text-blue-600" for="confirmPassword">Confirm Password</label> <br>
                       <input class="border w-full text-gray-400 p-2 mt-2 rounded-xl" :type="[showPassword3 ? 'text' : 'password']" name="confirmPassword" id="confirmPassword" v-model="confirmPassword">
                       <span @click="showPassword3 = !showPassword3">
                            <i class="fa  -ml-8 mt-4" :class="[showPassword3 ? 'fa-eye' : 'fa-eye-slash']" aria-hidden="false" ></i>
                        </span>
                       <p v-if="confirmPasswordValidity === 'invalid' " class="text-xs text-red-500">Password did not match</p>
                   </div>
                <p class="text-red-500 text-xs">{{wrong}}</p>

                    <div class="mt-6 flex">
                        <button class="bg-blue-700 text-white p-2 rounded-xl">Save Changes</button>
                        <i v-if="isLoading" class="fa  fa-spinner fa-spin  ml-4 text-blue-600"></i>    
                    </div>
               </form>
           </div>
       </div>
    </section>
</template>


<script>
import axios from 'axios';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    data() {
        return {
            oldPassword: "",
            newPassword: "",
            confirmPassword: "",
            isLoading: false,
            isPasswordChanged: false,
            showPassword: false,
            showPassword2: false,
            showPassword3: false,

            oldPasswordValidity : "",
            newPasswordValidity : "",
            confirmPasswordValidity : "",
            userId : localStorage.getItem('userId'),
            wrong: ""
        }
    },

    mounted() {
        this.networkError();
    },

    methods: {
        changePassword() {
            if(!this.oldPassword) {
                this.oldPasswordValidity = 'invalid'
                setTimeout(() => {
                    this.oldPasswordValidity = ""
                }, 3000);
            } else if(!this.newPassword || this.newPassword.length <= 8) {
                this.newPasswordValidity = 'invalid'
                 setTimeout(() => {
                    this.newPasswordValidity = ""
                }, 3000);
            } else if (this.newPassword !== this.confirmPassword) {
                this.confirmPasswordValidity = "invalid"
            } else {
             this.isLoading = true
                axios({
                    method: 'PUT',
                    url: `${url}/v1/web/users/password/update`,
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: 'Bearer' + localStorage.getItem("token"),
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data: {
                        userId : this.userId,
                        oldPassword: this.oldPassword,
                        newPassword : this.newPassword
                    }
                })
                .then((response) => {
                    console.log(this.userId)
                    this.isLoading = false
                    console.log(response)
                    this.isPasswordChanged = true
                    setTimeout(() => {
                        this.isPasswordChanged = false
                    }, 3000);
                    this.oldPassword = ""
                    this.newPassword = ""
                    this.confirmPassword = ""
                })
                .catch((error) => {
                    this.wrong = error.response.data.message
                    this.isLoading = false;
                    setTimeout(() => {
                        this.wrong = false
                    }, 3000);
                })
            }
        },

        networkError() {
            if(!navigator.onLine) {
                this.$router.push('/network-error')
            } 
        }
    }
}
</script>